var _style, _defs, _defs2, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135.6 116.4",
    style: {
      enableBackground: "new 0 0 135.6 116.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000108283045690520374790000014943851325664076436_);}\n\t.st1{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{mask:url(#mask0_2443_1930_00000178885819504568359090000017147095334161220226_);}\n\t.st3{fill:#CF896D;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 26.3,
    y: -0.6,
    width: 78.4,
    height: 115.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176726204637399507180000004089428748484135857_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176726204637399507180000004089428748484135857_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 26.2,
    y: 0.4,
    width: 78.4,
    height: 114.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 26.2,
    y: 0.4,
    width: 78.4,
    height: 114.4,
    id: "mask0_2443_1930_00000178885819504568359090000017147095334161220226_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.7-0.6H26.3v115.4h78.4V-0.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.4,33.8l3.4,1.8c0.4,0.2,0.6,0.4,0.8,0.8l1.8,3.4l1.8-3.4c0.2-0.3,0.4-0.6,0.8-0.8l3.4-1.8L41,32 c-0.4-0.2-0.6-0.4-0.8-0.8l-1.8-3.4l-1.8,3.4c-0.2,0.3-0.4,0.6-0.8,0.8L32.4,33.8z M38.3,45.9c-0.7,0-1.4-0.4-1.8-1l-3.3-6 c0,0-6-3.3-6-3.3c-1.4-0.7-1.3-2.7,0-3.5l6-3.3c0,0,3.3-6,3.3-6c0.7-1.3,2.8-1.3,3.5,0l3.3,6c0,0,6,3.3,6,3.3 c1.3,0.7,1.4,2.7,0,3.5l-6,3.3c0,0-3.3,6-3.3,6C39.7,45.6,39,45.9,38.3,45.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.5,10.4c-0.5,0.3-0.5,1,0,1.3l0.9,0.5c1,0.5,1.9,1.4,2.4,2.4l0.6,1.1c0.2,0.4,0.8,0.4,1.1,0l0.6-1.1 c0.5-1,1.4-1.9,2.4-2.4l1.3-0.7c0.4-0.2,0.4-0.7,0-0.9l-1.3-0.7c-1-0.5-1.9-1.4-2.4-2.4l-0.8-1.4c-0.2-0.3-0.6-0.3-0.7,0 l-0.8,1.4c-0.5,1-1.4,1.9-2.4,2.4L54.5,10.4z M59.6,21.7c-0.3,0.5-0.9,0.5-1.2,0L55.3,16c-0.3-0.5-0.7-1-1.3-1.3l-5.4-3 c-0.6-0.3-0.6-1.1,0-1.4l5.4-3c0.5-0.3,1-0.7,1.3-1.3l2.9-5.2c0.3-0.6,1.3-0.6,1.6,0l2.9,5.2c0.3,0.5,0.7,1,1.3,1.3l5.4,3 c0.6,0.3,0.6,1.1,0,1.4l-5.4,3c-0.5,0.3-1,0.7-1.3,1.3L59.6,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.3,59.5c3.5,7.1,6,14.6,6,21.3c0,20.3-9.5,30.1-29,30.1s-29-9.9-29-30.1c0-20.2,22.9-47.4,29-54.1 c2.2,2.5,6.7,7.7,11.6,14.3l2.1-3.9c-6.2-8.4-11.7-14.2-12.2-14.7c-0.7-0.8-2.1-0.8-2.9,0c-1.3,1.3-31.5,33.3-31.5,58.4 c0,22.3,11.4,34.1,32.9,34.1c21.6,0,32.9-11.8,32.9-34.1c0-8-3.1-16.8-7.4-25l-0.9,0.5L92.3,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.1,82.5C50,81,49.9,79.5,49.9,78c0-6.3,2.9-13.9,8.8-22.7c0.6-0.9,0.4-2.1-0.6-2.7 c-0.9-0.6-2.1-0.4-2.8,0.5c-6.3,9.4-9.4,17.8-9.4,24.9c0,1.7,0.1,3.4,0.3,4.9c0.1,1,1,1.8,2,1.8c0.1,0,0.2,0,0.2,0 C49.4,84.5,50.2,83.5,50.1,82.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M63.4,101c-4.4-1.8-7.7-4.4-9.9-8c-0.6-0.9-1.8-1.2-2.8-0.6c-0.9,0.6-1.2,1.8-0.6,2.7 c2.7,4.3,6.7,7.6,11.9,9.6c0.3,0.1,0.5,0.1,0.7,0.1c0.8,0,1.5-0.5,1.9-1.2C65,102.6,64.5,101.4,63.4,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.6,47.6l-9.6-5.2l-5.2-9.5c-0.4-0.6-1-1.1-1.8-1.1c-0.7,0-1.4,0.4-1.8,1.1L83,37.1 c0.9,1.1,1.7,2.3,2.6,3.6l1.5-2.7l3.7,6.9c0.2,0.3,0.4,0.6,0.8,0.8l6.9,3.7l-5.5,3c0.6,1.1,1.3,2.3,1.9,3.5l8.7-4.8 c0.6-0.4,1-1,1-1.8C104.6,48.6,104.3,47.9,103.6,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.3,53.9c-0.2-0.3-0.4-0.6-0.8-0.8l-6.9-3.7l6.9-3.7c0.3-0.2,0.6-0.4,0.8-0.8l0.1-0.2 c-0.9-1.2-1.7-2.5-2.6-3.6l-0.7,1.4l-9.6,5.2c-0.6,0.4-1,1-1,1.8c0,0.7,0.4,1.4,1,1.8l9.6,5.2l5.2,9.5c0.4,0.6,1,1,1.8,1 c0.7,0,1.4-0.4,1.8-1l3.5-6.3c-0.7-1.4-1.4-2.8-2.2-4.2l-3,5.5L83.3,53.9L83.3,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.4,44.6l2.2-4c-0.9-1.2-1.7-2.4-2.6-3.6L80.9,41C81.7,42.1,82.6,43.3,83.4,44.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.7,53.1c-0.4,0.2-0.6,0.4-0.8,0.8l-0.8,1.4c0.8,1.4,1.5,2.8,2.2,4.2l1.8-3.2l0.9-0.5 c-0.6-1.2-1.2-2.4-1.9-3.5L91.7,53.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.4e51c88af1384e905d2956b14846b4cb.svg";
export { ForwardRef as ReactComponent };